import React from 'react';
import { ReviewEntities } from 'client/data/models/dealer-reviews';

import './user-comment.scss';

export function UserComment({ comment }) {
  return (
    <div className="user-comment pos-r bg-cool-gray-90 px-1_5 py-1_5 mt-2_5 rounded-16">
      <p className="size-16">{comment.text}</p>
      <p className="size-14 text-cool-gray-40 mb-0 user-comment-author d-flex align-items-center">
        {comment.dealerComment && <i className="icon-checkmark-circle text-success pe-0_5 size-16" aria-hidden />}by{' '}
        {comment.authorName} on {comment.created}
      </p>
    </div>
  );
}

UserComment.propTypes = {
  comment: ReviewEntities.CommentsEntity.isRequired,
};
